import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import Loading from "../../../../Extra/Loading";

import DownloadExcel from "../../../../Extra/DownloadExcel";
import TWSBlockUpdate from "../../../../InsertData/TWSBlock/TWSBlockUpdate";
import { getCurrentDate, getCurrentMonthFirstDate } from "../../../../Utilitie";

const TWSBlockReport = () => {
  const urlPrefixBlock = process.env.REACT_APP_URL_BLOCK_PREFIX;
  const [rawData, setRawData] = useState([]);
  const tableRef = useRef();
  const [startDate, setStartDate] = useState(getCurrentMonthFirstDate());
  const [endDate, setEndDate] = useState(getCurrentDate());
  const [totalRow, setTotalRow] = useState();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const keys = [
    "Sr no.",
    "reportDate",
    "Direction",
    "section",
    "From_Station",
    "To_Station",
    "Yard",
    "Block_Type",
    "MAIN_LOOP_LINE",
    "CrossOver",
    "SPEED_POTENTIAL",
    "REMARKS",
  ];

  const fetchedData = async () => {
    setLoading(true);
    setError(false);
    try {
      const response = await axios.get(
        `${urlPrefixBlock}getTWSData?start=${startDate}&end=${endDate}`
      );
      if (response.data.status === "ok") {
        setRawData(response.data.daterange.data);
      } else {
        setRawData([]);
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch stations:", error);
      setLoading(false);
      setError(true);
    }
  };

  useEffect(() => {
    fetchedData();
  }, []);

  ////////////

  return (
    <div>
      <div className="d-flex justify-content-between bg-dark text-white p-1 papaDiv">
        <h5 className="">TWS Block Report </h5>
        <div>
          <div className="d-flex  align-items-center ">
            <b>From </b>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="me-1"
            />

            <b>To </b>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
            <button
              className="ms-1 btn btn-sm btn-outline-light"
              onClick={fetchedData}
            >
              Fetch
            </button>
          </div>
        </div>
      </div>

      <div
        className="table-responsive position-relative"
        style={{ maxHeight: "750px", overflowY: "auto" }}
      >
        <table
          ref={tableRef}
          className="table table-bordered table-striped mb-4 papaDiv"
          style={{ fontSize: "12px" }}
        >
          <thead className="table-dark text-center sticky-top">
            <tr>
              {keys.map((key) => {
                return (
                  <th key={key} className="border-white">
                    {key.toUpperCase().replace(/_/g, " ")}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {rawData.map((row, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{row.reportDate.slice(0, 10)}</td>
                <td>{row.Direction}</td>
                <td>{row.section}</td>
                <td>{row.From_Station}</td>
                <td>{row.To_Station}</td>
                <td>
                  {row.From_Station == row.To_Station ? "YARD" : "SECTION"}
                </td>
                <td>{row.Block_Type}</td>
                <td>{row.MAIN_LOOP_LINE}</td>
                <td>{row.CrossOver}</td>
                <td>{row.SPEED_POTENTIAL}</td>
                <td>{row.REMARKS}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="m-1">
        {!rawData ? (
          <b style={{ color: "red", fontSize: "14px" }}>Data not found!</b>
        ) : null}
        <DownloadExcel
          tableRef={tableRef}
          fileName={`TWS Block Report - ${startDate}-${endDate}`}
        />
      </div>
    </div>
  );
};

export default TWSBlockReport;
